import { render, staticRenderFns } from "./DealerShipping.vue?vue&type=template&id=65b140ad&scoped=true"
import script from "./DealerShipping.vue?vue&type=script&lang=js"
export * from "./DealerShipping.vue?vue&type=script&lang=js"
import style0 from "./DealerShipping.vue?vue&type=style&index=0&id=65b140ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b140ad",
  null
  
)

export default component.exports